// Оглавление пользовательской документации CandB.pro.
// При добавлении новой статьи: положить .md в подпапку и добавить запись сюда.
// path формируется как `${section}/${slug}`, файл — `${section}/${slug}.md`.

export const sections = [
  {
    slug: 'intro',
    title: 'Начало работы',
    articles: [
      { slug: 'what-is-step-m', title: 'Что такое CandB.pro' },
      { slug: 'roles', title: 'Роли пользователей' },
      { slug: 'login', title: 'Вход в систему' },
    ],
  },
  {
    slug: 'hr',
    title: 'HR-менеджеру',
    articles: [
      { slug: 'structure-import', title: 'Импорт данных из Excel' },
      { slug: 'structure-manual', title: 'Ручное создание структуры' },
      { slug: 'delegation', title: 'Делегирование доступа' },
      { slug: 'indicators', title: 'Индикаторы (KPI)' },
      { slug: 'parameters', title: 'Параметры' },
      { slug: 'variables', title: 'Переменные' },
      { slug: 'functions', title: 'Функции для формул' },
      { slug: 'formulas', title: 'Формулы расчёта' },
      { slug: 'regulation', title: 'Положение о премировании' },
      { slug: 'calculations', title: 'Запуск расчётов' },
      { slug: 'targets', title: 'Стратегия и KPI' },
      { slug: 'emp-kpi', title: 'Показатели эффективности (KPI-карта)' },
    ],
  },
  {
    slug: 'manager',
    title: 'Руководителю',
    articles: [
      { slug: 'team', title: 'Просмотр команды' },
      { slug: 'tasks', title: 'Управление задачами' },
      { slug: 'team-kpi', title: 'KPI команды' },
    ],
  },
  {
    slug: 'employee',
    title: 'Сотруднику',
    articles: [
      { slug: 'profile', title: 'Личный кабинет' },
      { slug: 'motivation', title: 'История начислений' },
      { slug: 'kpi', title: 'Показатели эффективности' },
      { slug: 'tasks-personal', title: 'Свои задачи' },
      { slug: 'chat', title: 'Чат с коллегами' },
    ],
  },
  {
    slug: 'integrations',
    title: 'Интеграции',
    articles: [
      { slug: 'telegram', title: 'Telegram-бот' },
      { slug: 'email', title: 'Корпоративная почта' },
      { slug: 'api', title: 'REST API и Webhook' },
    ],
  },
]

export function findArticle(sectionSlug, articleSlug) {
  if (!sectionSlug) {
    const first = sections[0]
    return { section: first, article: first.articles[0] }
  }
  const section = sections.find(s => s.slug === sectionSlug)
  if (!section) return null
  if (!articleSlug) return { section, article: section.articles[0] }
  const article = section.articles.find(a => a.slug === articleSlug)
  if (!article) return null
  return { section, article }
}

export function articlePath(section, article) {
  return `/docs/${section.slug}/${article.slug}`
}
